import styles from './GameConnector.module.scss';

import { FC, useCallback } from 'react';

import { GameConnectorTabs } from './GameConnectorTabs';
import { Button } from '@shared/Button';
import { useAppDispatch, useAppSelector } from '@app/store';
import { useGameControllerStartSessionMutation } from '@app/store/api/tunedRestApi';
import { initializeGameSocket } from '@app/store/api/dev_hack/gameSocket';

const devMode = import.meta.env.VITE_DEVELOP_MODE;

export const GameConnector: FC<{ classnameWrap?: string; classnameNav?: string }> = ({
  classnameWrap,
  classnameNav,
}) => {
  return devMode === 'true' ? (
    <GameConnectorDEV classnameWrap={classnameWrap} classnameNav={classnameNav} />
  ) : (
    <GameConnectorPROD classnameWrap={classnameWrap} classnameNav={classnameNav} />
  );
};

const GameConnectorPROD: FC<{ classnameWrap?: string; classnameNav?: string }> = ({
  classnameWrap,
}) => {
  const connected = useAppSelector((s) => s.game.connected);
  const loading = useAppSelector((s) => s.game.isLoading);
  const [connect, { isLoading }] = useGameControllerStartSessionMutation();

  let content = <>No games</>;

  if (loading || isLoading || connected) {
    content = <GameConnectorTabs />;
  } else if (!connected) {
    content = <Button title="Connect" variant="text" onClick={() => connect()} />;
  }
  return <div className={classnameWrap ?? styles.gamesContainer}>{content}</div>;
};

const GameConnectorDEV: FC<{ classnameWrap?: string; classnameNav?: string }> = ({
  classnameWrap,
}) => {
  const dispatch = useAppDispatch();
  const connected = useAppSelector((s) => s.game.connected);
  const loading = useAppSelector((s) => s.game.isLoading);

  const handleConnect = useCallback(async () => {
    try {
      // Теперь используем глобальную функцию
      initializeGameSocket(dispatch);
    } catch (error) {
      console.error('Failed to connect:', error);
    }
  }, [dispatch]);

  let content = <>No games</>;

  if (loading || connected) {
    content = <GameConnectorTabs />;
  } else if (!connected) {
    content = <Button title="Connect" variant="text" onClick={handleConnect} />;
  }
  return <div className={classnameWrap ?? styles.gamesContainer}>{content}</div>;
};
